import ColumnGroup, { ColumnGroupProps } from 'antd/lib/table/ColumnGroup';
// export default withConfigProvider(ColumnGroup);
export default ColumnGroup;
